var map = {
	"./basketball.webp": 1563,
	"./bti-img.webp": 1564,
	"./bti-title-en.webp": 1565,
	"./cup.webp": 1566,
	"./football.webp": 1567,
	"./im-img.webp": 1568,
	"./im-title-en.webp": 1569,
	"./sb-img.webp": 1570,
	"./sb-title-cn.webp": 1571,
	"./sb-title-en.webp": 1572,
	"./sbo-img.webp": 1573,
	"./sbo-title-cn.webp": 1574,
	"./sbo-title-en.webp": 1575,
	"./sport-bg.webp": 1576,
	"./sport-ctg.webp": 1577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 777;